import {
  tableState,
  tableMutations,
  tableActions,
  tableGetters
} from "@tt/vue-components";
import InventoryService from "@/services/InventoryService";
import locationCodeOrNameFilter from "@/store/modules/skus/stockMutations/filters/locationCodeOrNameFilter";

const stockMutations = {
  requestController: null,
  namespaced: true,
  modules: {
    locationCodeOrNameFilter
  },
  state: {
    ...tableState,
    pagination: {itemsPerPage: 10, itemsPage: 1},
    footerProps: {"items-per-page-options": [10, 20, 40, 80]},
    sorting: { sortBy: ["processedDt"], sortDesc: [true] },
  },
  mutations: {
    ...tableMutations,
  },
  actions: {
    ...tableActions,
    fetchItems({ commit, state, rootState }, refresh = false) {
      if (refresh || state.items.length === 0) {
        commit("SET_LOADING", true);
        const params = {
          pagination: state.pagination,
          sorting: state.sorting,
          search: state.search
        };

        const id = rootState.skusOverview.sku.sku;

        InventoryService.skus.getSubResourceAlt('stock_mutations', id, params)
          .then(json => {
            if (json) {
              commit("SET_ITEMS", json);
            }
          })
          .catch(err => {
            console.log(err);
          })
          .finally(() => {
            commit("SET_LOADING", false);
          });
      }
    }
  },
  getters: {
    ...tableGetters
  }
};

export default stockMutations;
